import { ExecutionContext } from '@/services/executor';
import { Card } from '@/components/ui/card';
import { CheckCircle, AlertCircle, Clock } from 'lucide-react';

interface ExecutionResultsProps {
  results: ExecutionContext[];
}

export function ExecutionResults({ results }: ExecutionResultsProps) {
  if (results.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <p>No execution results yet. Run a workflow to see results.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {results.map((result) => (
        <Card key={result.nodeId} className="p-3 space-y-2">
          <div className="flex items-center justify-between">
            <code className="text-xs font-mono text-muted-foreground">
              {result.nodeId}
            </code>
            <div className="flex items-center gap-2">
              {result.errors.length > 0 ? (
                <AlertCircle className="w-4 h-4 text-destructive" />
              ) : (
                <CheckCircle className="w-4 h-4 text-green-600" />
              )}
              <span className="text-xs text-muted-foreground">
                {new Date(result.timestamp).toLocaleTimeString()}
              </span>
            </div>
          </div>

          {result.errors.length > 0 && (
            <div className="text-xs text-destructive bg-destructive/10 p-2 rounded">
              {result.errors.map((err, i) => (
                <p key={i}>{err}</p>
              ))}
            </div>
          )}

          {result.output && (
            <pre className="text-xs bg-muted/50 p-2 rounded overflow-auto max-h-32">
              {JSON.stringify(result.output, null, 2)}
            </pre>
          )}
        </Card>
      ))}
    </div>
  );
}
